import { Component } from "@angular/core";
import { XOField } from './xo-field.component';

@Component({
    selector: "xo-field-string",
    templateUrl: "./xo-field-string.component.html"
})
export class XOFieldString extends XOField {
}
